import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {CurrencyFormatter, PercentFormatter, UnitFormatter} from "../../../utils/formatters";
import BigNumber from "bignumber.js";

class RoyaltyRangeList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        let {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "RoyaltyRangeList"}
                {...props}
                columns={{
                    [componentConfig.idfield]: {
                        header: 'Kód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "amount": {
                        header: 'Százalék',
                        width: 6,
                        sortable,
                        filterable,
                        renderer: (value) => PercentFormatter(new BigNumber(value).multipliedBy(100).toNumber()),
                        className: "percent"
                    },
                    "limit": {
                        header: 'Alsó küszöb',
                        width: 6,
                        sortable,
                        filterable,
                        renderer: (value, row) => UnitFormatter(value),
                        className: "unit",
                    },
                }}
                orderBy={{field: "limit", direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default RoyaltyRangeList;
